import React from 'react';

export default function ArrowDown({ iconClass }: { iconClass?: string }) {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      aria-hidden="true"
      focusable="false"
      role="img"
      className={iconClass}
    >
      <path d="m303.5 569 17 17 17-17 168-168 17-17-33.9-33.9-17 17-127 127V64h-48v430.1l-127-127-17-17-33.9 33.9 17 17 168 168z" />
    </svg>
  );
}
